import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export function aboutFunc() {
  const buttons = document.querySelectorAll('.js-button');
  buttons.forEach(button => {
    button.addEventListener('click', () => {
      let parent = button.closest('.js-profile');
      if (parent) {
        parent.classList.toggle('active');
        button.textContent = parent.classList.contains('active') ? 'Close' : 'View Profile';
      }
    });
  });

  ScrollTrigger.matchMedia({
    // Desktop
    "(min-width: 768px)": function() {
      gsap.set('.p-about__move__logical', { x: '-180%', y: '0' });
      gsap.set('.p-about__move__emotional', { x: '180%', y: '0' });
      gsap.set('.p-about__move__plus', { opacity: 0 });
      gsap.set('.p-about__move__text', { opacity: 0 });

      // 共通のScrollTrigger設定
      const scrollTriggerSettings = {
        trigger: '.p-about__move',
        start: 'top top',
        end: 'bottom top',
        scrub: 2,
        // markers: true,
        pin: true,
      };

      const tl = gsap.timeline({
        scrollTrigger: scrollTriggerSettings
      });

      tl.to('.p-about__move__logical', { x: '0%', y: '0', duration: 2 })
        .to('.p-about__move__emotional', { x: '0%', y: '0', duration: 2 }, '<')
        .to('.p-about__move__plus', { opacity: 1, duration: 2 }, '<')
        .to('.p-about__move__text', { opacity: 1, duration: 2 }, '<')
        .to({}, { duration: 2 })
        .add('scene1')
        .to('.p-about__move__logical', { x: '78%', y: '0', duration: 2 })
        .to('.p-about__move__emotional', { x: '-67%', y: '0', duration: 2 }, 'scene1')
        .to('.p-about__move__text', { opacity: 0, duration: 2 }, 'scene1')
        .to('.p-about__move__plus', { opacity: 0, duration: 2 }, 'scene1')
        .add('scene2')
        .to('.p-about__move__logical', { opacity: 0, duration: 2 })
        .to('.p-about__move__emotional', { opacity: 0, duration: 2 }, 'scene2')
        .to('.p-about__move__circle', { opacity: 1, duration: 2 }, 'scene2')
        .to({}, { duration: 2 })
        .to('.p-about__move__circle', { width: '250vw', height: '250vw', duration: 1 })
        .to('.p-about__move__logo', { opacity: 0, duration: 2 })
    },

    // Mobile
    "(max-width: 767px)": function() {
      gsap.set('.p-about__move__logical', { x: '-160%', y: '0' });
      gsap.set('.p-about__move__emotional', { x: '160%', y: '0' });
      gsap.set('.p-about__move__plus', { opacity: 0 });
      gsap.set('.p-about__move__text', { opacity: 0 });

      // 共通のScrollTrigger設定
      const scrollTriggerSettings = {
        trigger: '.p-about__move',
        start: 'top top',
        end: 'bottom top',
        scrub: 2,
        // markers: true,
        pin: true,
      };

      const tl = gsap.timeline({
        scrollTrigger: scrollTriggerSettings
      });

      tl.to('.p-about__move__logical', { x: '0%', y: '0', duration: 2 })
        .to('.p-about__move__emotional', { x: '0%', y: '0', duration: 2 }, '<')
        .to('.p-about__move__plus', { opacity: 1, duration: 2 }, '<')
        .to('.p-about__move__text', { opacity: 1, duration: 2 }, '<')
        .to({}, { duration: 2 })
        .add('scene1')
        .to('.p-about__move__logical', { x: '64%', y: '0', duration: 2 })
        .to('.p-about__move__emotional', { x: '-58%', y: '0', duration: 2 }, 'scene1')
        .to('.p-about__move__text', { opacity: 0, duration: 2 }, 'scene1')
        .to('.p-about__move__plus', { opacity: 0, duration: 2 }, 'scene1')
        .add('scene2')
        .to('.p-about__move__logical', { opacity: 0, duration: 2 })
        .to('.p-about__move__emotional', { opacity: 0, duration: 2 }, 'scene2')
        .to('.p-about__move__circle', { opacity: 1, duration: 2 }, 'scene2')
        .to({}, { duration: 2 })
        .to('.p-about__move__circle', { width: '250vw', height: '250vw', duration: 1 })
        .to('.p-about__move__logo', { width: '64vw' }, '<')
        .to('.p-about__move__logo', { opacity: 0, duration: 2 })
    }
  });
}